<template>
	<div>
		<h3>{{ $t('monte.add_jument') }}</h3>
		<ActionOverlay ref="saveOverlay" />
		<div>
            <form @submit.prevent>
	            <div class="form-group">
	                <label>
						{{ $t('monte.jument') }}
						<span class="ml-1" v-if="mare && mare.horse_id">
							<router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: mare.horse_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
	                <div class="row">
	                	<div class="col">
			                <SearchJument
								:horse_selected.sync="mare"
								:preselected="mare"
								:online="true"
							/>
			            </div>
			            <div class="col-auto">
		                	<button class="btn btn-secondary" @click="addMare"><font-awesome-icon :icon="['far', 'plus']" /></button>
		                </div>
		            </div>
	            </div>
				<div class="form-group">
	                <div class="row">
	                	<div class="col-12">
			            	<div class="d-flex">
								<b-form-radio v-model="showTier" :value="false" class="mr-2">{{ $t('monte.contact') }}</b-form-radio>
								<b-form-radio v-model="showTier" :value="true" class="mr-2 mb-2">{{ $t('monte.tiers') }}</b-form-radio>
								<span class="ml-1" v-if="showTier && tiers && tiers.tiers_id">
									<router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: tiers.tiers_id }}">
										<font-awesome-icon :icon="['fal', 'link']" />
									</router-link>
								</span>
								<span class="ml-1" v-else-if="contact && contact.contact_id">
									<router-link :to="{ name: 'contactCoordonnees', params: { contact_id: contact.contact_id }}">
										<font-awesome-icon :icon="['fal', 'link']" />
									</router-link>
								</span>
			            	</div>
			            </div>
	                	<div class="col">
			            	<SearchTiers
			            		v-if="showTier"
								:tiers_selected.sync="tiers"
								:search_value.sync="tiers_search_value"
								:preselected="tiers"
								:online="true"
							/>
							<SearchContact
			            		v-else
								:contact_selected.sync="contact"
								:search_value.sync="contact_search_value"
								:preselected="contact"
								:online="true"
							/>
		                </div>
		                <div class="col-auto">
		                	<button class="btn btn-secondary" @click="addTierOrContact"><font-awesome-icon :icon="['far', 'plus']" /></button>
		                </div>
		            </div>
	            </div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	            	<label>
						{{ $t('mouvement.lieu_stationnement') }}
						<span class="ml-1" v-if="lieu_stationnement && lieu_stationnement.tiers_id">
							<router-link :to="{ name: 'tiersTableauBord', params: { tiers_id: lieu_stationnement.tiers_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
					<SearchTiers
						v-if="showLieuStationnement"
						:tiers_selected.sync="lieu_stationnement"
						:preselected="lieu_stationnement"
						:online="true"
					/>
	            </div>
	            <div v-if="!no_couple && no_contract" class="alert alert-warning">{{ $t('monte.no_contract') }}</div>
	            <div v-if="no_couple" class="alert alert-warning">{{ $t('monte.no_couple') }}</div>
	            <div v-if="selected_stallion_saillie_count > 0" class="alert alert-warning">{{ $t('monte.saillie_count', { count: selected_stallion_saillie_count }) }}</div>
	            <div v-if="stallion_preselected" class="alert alert-danger">{{ $t('monte.defaut_stallion_is') }} {{ default_stallion.horse_nom }}</div>
	            <div v-if="stallion_selected" class="alert alert-warning">{{ $t('monte.stallion_selected') }}</div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	                <label>{{ $t('gynecologie.mare_status_monte') }}</label>
	                <div class="row">
	                	<div class="col">
			                <e-select
	                            v-model="mare_status_selected"
	                            id="marestatus_id"
	                            track-by="marestatus_id"
	                            :placeholder="$t('gynecologie.selectionnez_etat')"
	                            :selectedLabel="$t('global.selected_label')"
	                            :options="mare_status"
	                            :searchable="false"
	                            :allow-empty="false"
	                            :show-labels="false"
	                        >
	                            <template slot="option" slot-scope="{ option }">{{ $t('gynecologie.'+option.marestatus_code) }}</template>
	                            <template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.'+option.marestatus_code) }}</template>
	                            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
	                        </e-select>
	                    </div>
		            </div>
	            </div>
	            <div v-if="mare && mare.horse_id" class="form-group">
	            	<div class="row">
	                	<div class="col">
	            			<b-form-checkbox id="seasonmare_sanitary_ia" v-model="sanitary"><label for="seasonmare_sanitary_ia">{{ $t("gynecologie.sanitaire_complet") }}</label></b-form-checkbox>
	            		</div>
	            	</div>
	            </div>
	            <div class="form-group">
	            	<label>{{ $t('monte.stallion_singular') }}
						<span class="ml-1" v-if="stallion && stallion.horse_id">
							<router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: stallion.horse_id }}">
								<font-awesome-icon :icon="['fal', 'link']" />
							</router-link>
						</span>
					</label>
	                <e-select
	                    v-model="stallion"
	                    id="stallion"
	                    track-by="horse_id"
	                    label="horse_nom"
	                    :placeholder="$t('monte.selectionnez_etalon')"
	                    :selectedLabel="$t('global.selected_label')"
	                    :options="stallion_dispo"
	                    :searchable="true"
	                    :allow-empty="false"
	                    :show-labels="false"
	                    :class="{ 'is-invalid': error && error.indexOf('stallion') > -1 }"
	                />
	            </div>
				<div class="row">
					<div class="form-group col-6">
						<label>{{ $t('monte.date') }}</label>
						<e-datepicker v-model="date"></e-datepicker>
					</div>
					<div class="form-group col-6">
						<label>{{ $t('monte.creneau') }}</label>
						<e-select
							v-model="schedule"
							id="schedule"
							track-by="schedule_id"
							:placeholder="$t('monte.selectionnez_schedule')"
							:selectedLabel="$t('global.selected_label')"
							:options="schedule_dispo"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
							:class="{ 'is-invalid': error && error.indexOf('schedule') > -1 }"
						>
							<template slot="option" slot-scope="{ option }">{{ option.schedule_start }} - {{ option.schedule_end }}</template>
							<template slot="singleLabel" slot-scope="{ option }">{{ option.schedule_start }} - {{ option.schedule_end }}</template>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>
				</div>

	            <div class="form-group">
                    <label>{{ $t('formulaire.ajouter_commentaire') }}</label>
                    <e-editor-froala
                        ref="froala_creneau_comment"
                        identifier="creneau_commentaire_ia"
                        :placeholder="$t('formulaire.votre_commentaire')"
                        :content="commentaire"
                        @change="updateCreneauCommentEditor"
                        :moreText="froala_more_text"
                        :enableImage="false"
                    ></e-editor-froala>
                </div>

	            <div class="form-group">
	            	<label class="d-block">{{ $t('monte.commentaire_color') }}</label>
	            	<div class="d-flex flex-wrap">
	            		<button
	            			v-for="color in comment_colors"
	            			:key="color"
	            			type="button"
	            			class="btn mr-2 mb-2"
	            			:class="['alert-' + color, commentaire_color === color ? 'border border-dark font-weight-bold' : '']"
	            			@click="commentaire_color = color"
	            		>
	            			{{ $t('monte.commentaire_color_' + color) }}
	            		</button>
	            	</div>
	            </div>

	            <div class="text-center mt-5">
	                <b-button @click="checkForm" variant="primary" class="rounded-pill" :disabled="processing">
	                    <template v-if="schedule_info">
	                    	{{ $t('global.modifier') }}
	                	</template>
	                	<template v-else>
	                    	{{ $t('global.ajouter') }}
	                	</template>
	                	<span class="ml-1 small opacity-50">({{ isMac ? '⌘' : 'Ctrl' }}+S)</span>
	                </b-button>
	                <b-button @click="cancelAjout" class="rounded-pill ml-1">
					{{ $t('global.annuler') }} <span class="ml-1 small opacity-50">(Esc)</span>
					</b-button>
	            </div>
	        </form>
        </div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import Constants from '../../../config.local'
	import ShutterPanel from 'GroomyRoot/components/Utils/ShutterPanel'
	import Shutter from '@/mixins/Shutter'
	import MonteShutters from '@/mixins/shutters-manager/Monte'
	import Horse from '@/mixins/Horse'
	import PlanningMonte from '@/mixins/PlanningMonte'
	import Gynecologie from '@/mixins/Gynecologie'
	import { parsePhoneNumberFromString as parseMax, AsYouType } from 'libphonenumber-js/max'

	export default {
		name: 'AjoutMonteIABeta',
		props: ['horse_id', 'schedule_info', 'planning_id', 'schedule_id', 'date_preselected', 'season_id', 'stallions', 'stallion_schedules'],
		mixins: [Shutter, MonteShutters, Horse, PlanningMonte, Gynecologie],
		data () {
			return {
				mare: {},
				stallion: null,
				stallion_dispo: [],
				contact: null,
				schedule: null,
				schedule_dispo: [],
				all_schedule: [],
				date: null,
				mare_status_selected: null,
				mare_status: [],
				sanitary: false,
				commentaire: "",
				commentaire_color: 'info',
				comment_colors: ['info', 'warning', 'danger', 'success'],
				froala_more_text: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting'],
				no_contract: false,
				no_couple: false,
				showTier: true,
				tiers: null,
				lieu_stationnement: null,
				stallion_preselected: false,
				stallion_selected: false,
				tiers_search_value: '',
				contact_search_value: '',
				error: [],
				processing: false,
				default_stallion: null,
				showLieuStationnement: true,
				mare_context: null
			}
		},

		mounted() {
			this.init_component()
			document.addEventListener('keydown', this._onKeydown)
		},

		beforeDestroy() {
			document.removeEventListener('keydown', this._onKeydown)
		},

		methods: {
			/**
			 * Synchronise le contenu de l'éditeur Froala du commentaire de créneau
			 */
			updateCreneauCommentEditor(hook) {
				this.commentaire = hook.val
			},

			async init_component() {
				this.mare_status = await this.loadMareStatus()

				if(!this.schedule_info) {
					this.loadStallion()
					if(this.date_preselected) {
						this.date = this.date_preselected
					}
				}
				else {
					this.mare = this.schedule_info.mare ? this.schedule_info.mare : {}
					this.date = new Date(this.schedule_info.date)
					this.contact = this.schedule_info.contact
					this.loadStallion(this.schedule_info.stallion.horse_id)
					this.commentaire = this.schedule_info.commentaire || ''
					this.commentaire_color = this.schedule_info.commentaire_color || 'info'
					this.$nextTick(() => {
						if(this.$refs.froala_creneau_comment) {
							this.$refs.froala_creneau_comment.setValue(this.commentaire)
						}
					})
					this.tiers = this.schedule_info.tiers
					if(this.tiers) {
						this.showTier = true
					}
					if(this.contact) {
						this.showTier = false
					}
				}

				this.all_schedule = [...new Map((this.stallion_schedules || []).map(ps => [ps.schedule.schedule_id, ps.schedule])).values()]
			},

			async addMare() {
				let shutter = this.monteShutters['monte-horse-ajout']
				shutter.props.season_id = this.season_id

				shutter.onOk = async (horse_id) => {
					if(this.contact) {
						await this.setContactHorse(horse_id)
					}
					this.mare = await this.getHorseById(horse_id)
				}

				this.shutterPanel().open(shutter)
			},

			addTierOrContact() {
				if(this.showTier) {
					this.openAddTier()
				}
				else {
					this.addContact()
				}
			},

			addContact() {
				let shutter = this.monteShutters['monte-contact-ajout']

				if(this.mare && this.mare.horse_id) {
					shutter.props.horse_id = this.mare.horse_id
				}

				this.shutterPanel().open(shutter)
			},

			openAddTier() {
				let shutter = this.monteShutters['ajout-tiers']

				this.shutterPanel().open(shutter)
			},

			async setContactHorse(horse_id) {
				if(this.contact.contact_id) {
					await this.addHorseContact(horse_id, this.contact.contact_id)
				}
			},

			async loadStallion() {
				this.stallion_dispo = this.stallions || []
				if(this.horse_id){
					this.stallion = this.stallion_dispo.find(stallion => stallion.horse_id == this.horse_id)
				} else if(this.stallion_dispo.length === 1){
					this.stallion = this.stallion_dispo[0]
				}
			},

			async loadSchedules() {
				const stallion_schedule_ids = (this.stallion_schedules || [])
					.filter(ps => ps.stallion.horse_id === this.stallion.horse_id)
					.map(ps => ps.schedule.schedule_id)
				this.schedule_dispo = this.all_schedule.filter(schedule => stallion_schedule_ids.includes(schedule.schedule_id))

				if(this.schedule_id) {
					this.schedule = this.schedule_dispo.find(schedule => schedule.schedule_id == this.schedule_id)
				} else if (this.schedule_dispo.length === 1){
					this.schedule = this.schedule_dispo[0]
				}
			},

			_onKeydown(e) {
				if((this.isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === 's') {
					e.preventDefault()
					if(!this.processing) {
						this.checkForm()
					}
				}
				if(e.key === 'Escape') {
					this.cancelAjout()
				}
			},

			cancelAjout() {
				this.cancel()
				this.shutterPanel().close('monte-horse-ajout')
				this.shutterPanel().close('monte-contact-ajout')
			},

			async checkForm() {
				if(!this.stallion || !this.stallion.horse_id) {
					this.failureToast('monte.no_stallion_selected')
					return
				}
				if(!this.schedule || !this.schedule.schedule_id) {
					this.failureToast('monte.no_schedule_selected')
					return
				}
				this.processing = true
				this.$refs.saveOverlay.show()

				const mare = (this.mare && this.mare.horse_id) ? this.mare.horse_id : null;
				const contact = (!this.showTier && this.contact) ? this.contact.contact_id : null;
				const tiers = (this.showTier && this.tiers && this.tiers.tiers_id) ? this.tiers.tiers_id : null;
				const schedulehorse_id = this.schedule_info ? this.schedule_info.id : null
				const seasonmare_id = this.mare_context ? this.mare_context.seasonmare_id : null

				if(mare && seasonmare_id && this.mare_status_selected) {
					await this.saveStatutSanitary(seasonmare_id, this.mare_status_selected.marestatus_id, this.sanitary)
				}
				else if(mare && seasonmare_id) {
					await this.saveStatutSanitary(seasonmare_id, null, this.sanitary)
				}

				if(mare && seasonmare_id) {
					const seasonmarestallion = await this.getSeasonMareStallionDefaultBySeasonMare(seasonmare_id)
					if(!seasonmarestallion || seasonmarestallion.seasonmarestallion_horse != this.stallion.horse_id) {
						await this.editAllSeasonMareStallionDefault(seasonmare_id, { seasonmarestallion_default: 0 })
						const seasonstallion = await this.getSeasonMareStallionBySeasonMareAndStallion(seasonmare_id, this.stallion.horse_id)
						if(!seasonstallion) {
							await this.addSeasonMareStallion(seasonmare_id, this.stallion.horse_id, null, 1)
						} else {
							await this.editSeasonMareStallion(seasonstallion.seasonmarestallion_id, { seasonmarestallion_default: 1 })
						}
					}

					if(this.mare.horse_id && this.lieu_stationnement && this.lieu_stationnement.tiers_id) {
						await this.assignLieuStationnement(this.mare.horse_id, this.lieu_stationnement.tiers_id)
					}
				}

				const comment_html = this.commentaire || ''
				const stripped = comment_html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim()
				const comment_text = stripped ? comment_html : ''
				const comment_color = stripped ? this.commentaire_color : null
				const res = await this.saveScheduleHorseOnline("IA", this.stallion.horse_id, this.schedule.schedule_id, mare, contact, this.date, schedulehorse_id, comment_text, tiers, comment_color)

				if(res) {
					await this.$refs.saveOverlay.showSuccess()
					this.processing = false
					this.ok()
					this.shutterPanel().close('monte-ia-ajout-beta')
					this.shutterPanel().close('monte-horse-ajout')
					this.shutterPanel().close('monte-contact-ajout')
				} else {
					this.$refs.saveOverlay.hide()
					this.processing = false
				}
			},

			formatPhone(number) {
				return new AsYouType(Vue.i18n.locale()).input(number)
			},

			async loadContractInfo() {
				this.no_contract = false
				if(!this.mare || !this.mare.horse_id) return false
				if(!this.stallion || !this.stallion.horse_id) return false

				if (this.mare_context && this.mare_context.season_stallions) {
					const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
					if (!match) {
						this.no_contract = true
					}
				} else {
					this.no_contract = true
				}
			},

			async checkSeasonMareStallion() {
				this.no_couple = false
				if(!this.stallion || !this.stallion.horse_id) return
				if(!this.mare_context) return

				if (this.mare_context.season_stallions && this.mare_context.season_stallions.length > 0) {
					const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
					if (!match) {
						this.no_couple = true
					}
				} else {
					this.no_couple = true
				}
			},

			async loadMareContext() {
				if (!this.mare || !this.mare.horse_id || !this.season_id) {
					this.mare_context = null
					return
				}

				const url = this.constructRoute(Constants.CONTRACT_MARE_CONTEXT_URL, {
					mare_id: this.mare.horse_id,
					season_id: this.season_id
				}) + '?licence_key=' + Constants.USER_LICENCE_KEY

				const res = await this.$request.request_get_api('AjoutMonteIABeta::loadMareContext', url)
					.catch(e => {
						console.error('AjoutMonteIABeta::loadMareContext', e)
						return null
					})

				if (res && res.retour) {
					this.mare_context = res.retour

					// Pré-remplir le lieu de stationnement
					if (this.mare_context.lieu_stationnement) {
						this.lieu_stationnement = this.mare_context.lieu_stationnement
					}

					// Pré-remplir le contact (responsable d'élevage en priorité)
					if (!this.schedule_info && this.mare_context.contacts && this.mare_context.contacts.length > 0) {
						const resp = this.mare_context.contacts.find(c => c.fonctions && c.fonctions.includes('RESPELEV'))
						this.contact = resp || this.mare_context.contacts[0]
					}

					// Pré-remplir le tiers (propriétaire principal)
					if (!this.schedule_info && this.mare_context.tiers && this.mare_context.tiers.length > 0) {
						this.tiers = this.mare_context.tiers[0]
						this.showTier = true
					}

					// Statut mare
					if (this.mare_context.seasonmare_status) {
						this.mare_status_selected = this.mare_status.find(s => s.marestatus_id == this.mare_context.seasonmare_status)
					}
					this.sanitary = this.mare_context.seasonmare_sanitary || false

					// Étalon par défaut
					this.stallion_preselected = false
					this.stallion_selected = false
					if (this.mare_context.season_stallions && this.mare_context.season_stallions.length > 0) {
						const defaultSms = this.mare_context.season_stallions.find(s => s.seasonmarestallion_default)
						if (defaultSms) {
							const new_stallion = this.stallion_dispo.find(st => st.horse_id == defaultSms.stallion_id)
							if (new_stallion && !this.stallion) {
								this.stallion = new_stallion
								this.stallion_selected = true
							}
							if (new_stallion && this.stallion && new_stallion.horse_id != this.stallion.horse_id) {
								this.default_stallion = new_stallion
								this.stallion_preselected = true
							}
						}
					}
				} else {
					this.mare_context = null
				}
			}
		},

		computed: {
			selected_stallion_saillie_count() {
				if (!this.mare_context || !this.stallion || !this.stallion.horse_id) return null
				if (!this.mare_context.season_stallions) return null
				const match = this.mare_context.season_stallions.find(s => s.stallion_id == this.stallion.horse_id)
				return match ? match.saillie_count : 0
			}
		},

		watch: {
			async mare (val) {
				await this.loadMareContext()
				this.loadContractInfo()
				this.checkSeasonMareStallion()
				this.showLieuStationnement = false
				this.$nextTick(() => {
					this.showLieuStationnement = true
				})
			},

			stallion (val) {
				if(val) {
					this.schedule = null
					this.loadSchedules()
					this.loadContractInfo()
					this.checkSeasonMareStallion()
				}
			},

			showTier(val) {
				if(val) {
					this.tiers_search_value = this.contact_search_value
				}
				else {
					this.contact_search_value = this.tiers_search_value
				}
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers'),
			SearchContact : () => import('@/components/Contract/SearchContact'),
			SearchJument : () => import('@/components/Contract/SearchJument'),
			ActionOverlay: () => import('@/components/Utils/ActionOverlay')
		}
	}

</script>
